module.exports = __webpack_public_path__ + "img/JavaScript_Object_Notation.a9ac3684.png";